import { makeStyles } from '@material-ui/core/styles';

export const DRAWER_WIDTH = 275;

export const useSidebarStyles = makeStyles((theme) => {
	const isDark = theme.palette.type === 'dark';
	const t = {
		border: isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
		textSecondary: theme.palette.text.secondary,
		textActive: '#FEF200',
		hoverBg: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
		activeBg: isDark ? 'rgba(254,242,0,0.12)' : 'rgba(254,242,0,0.22)',
		activeBar: '#FEF200',
		iconDefault: theme.palette.text.secondary,
		iconActive: '#FEF200',
		logoText: isDark ? theme.palette.text.primary : theme.palette.text.primary,
		parentHint: '#FEF200'
	};
	return {
		drawer: {
			width: DRAWER_WIDTH,
			flexShrink: 0,
			whiteSpace: 'nowrap',
			'& .MuiDrawer-paper': {
				scrollbarWidth: 'none',
				'-ms-overflow-style': 'none',
				'&::-webkit-scrollbar': {
					display: 'none'
				}
			}
		},
		drawerOpen: {
			width: DRAWER_WIDTH,
			transition: theme.transitions.create('width', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen
			})
		},
		drawerClose: {
			transition: theme.transitions.create('width', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen
			}),
			overflowX: 'hidden',
			width: theme.spacing(7) + 1,
			[theme.breakpoints.up('sm')]: {
				width: theme.spacing(9) + 1
			}
		},
		header: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			minHeight: 64,
			padding: theme.spacing(1, 1, 1, 2),
			borderBottom: `1px solid ${t.border}`
		},
		headerLogoWrap: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			overflow: 'hidden',
			flex: 1
		},
		headerLogoImg: {
			maxWidth: '100%',
			objectFit: 'contain'
		},
		headerCompany: {
			fontSize: '1.45em',
			fontWeight: 600,
			color: t.logoText,
			marginTop: 0,
			marginBottom: 0,
			textAlign: 'center',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			maxWidth: '100%'
		},
		headerCompanyNoLogo: {
			fontSize: 'x-large',
			fontWeight: 700,
			color: t.logoText,
			margin: 0,
			textAlign: 'center',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			maxWidth: '100%'
		},
		headerToggle: {
			color: t.textSecondary,
			padding: 6
		},
		listRoot: {
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1)
		},
		itemRoot: {
			position: 'relative',
			minHeight: 40,
			margin: '2px 6px',
			padding: '6px 8px 6px 16px',
			borderRadius: 8,
			'&:hover': {
				backgroundColor: t.hoverBg
			},
			'&.Mui-disabled': {
				opacity: 0.45
			}
		},
		itemRootCollapsed: {
			padding: '6px 4px',
			margin: '2px 2px',
			overflow: 'hidden',
			justifyContent: 'center'
		},
		itemRootCollapsedL1Indent: {
			paddingLeft: 6,
			justifyContent: 'flex-start'
		},
		itemRootCollapsedL2: {
			paddingLeft: 22,
			justifyContent: 'flex-start',
			'&::before': {
				content: '""',
				position: 'absolute',
				left: 12,
				top: 8,
				bottom: 8,
				width: 1.5,
				backgroundColor: t.border,
				borderRadius: 1
			}
		},
		itemRootCollapsedL3: {
			paddingLeft: 38,
			justifyContent: 'flex-start',
			'&::before': {
				content: '""',
				position: 'absolute',
				left: 28,
				top: 8,
				bottom: 8,
				width: 1.5,
				backgroundColor: t.border,
				borderRadius: 1
			}
		},
		itemIconCollapsed: {
			marginRight: 0
		},
		itemL2: {
			paddingLeft: 40,
			color: t.textSecondary
		},
		itemL3: {
			paddingLeft: 64,
			color: t.textSecondary
		},
		itemActive: {
			backgroundColor: t.activeBg,
			'&:hover': {
				backgroundColor: t.activeBg
			},
			'&::before': {
				content: '""',
				position: 'absolute',
				left: 0,
				top: '50%',
				transform: 'translateY(-50%)',
				width: 3,
				height: 24,
				borderRadius: 2,
				backgroundColor: t.activeBar
			}
		},
		itemActiveParent: {
			'& $itemLabel': {
				color: t.parentHint
			},
			'& $itemIcon': {
				color: t.parentHint
			}
		},
		itemIcon: {
			minWidth: 0,
			marginRight: 12,
			color: t.iconDefault,
			'& svg': {
				fontSize: 18
			}
		},
		itemIconActive: {
			color: t.iconActive
		},
		itemLabelL1: {
			fontSize: 14,
			fontWeight: 600,
			letterSpacing: 0.2,
			color: 'inherit'
		},
		itemLabelL2: {
			fontSize: 13,
			fontWeight: 500,
			letterSpacing: 0.1,
			color: 'inherit'
		},
		itemLabelL3: {
			fontSize: 12.5,
			fontWeight: 400,
			color: 'inherit'
		},
		itemLabelActive: {
			fontWeight: 700,
			color: t.textActive
		},
		itemLabel: {
			color: 'inherit'
		},
		expandIcon: {
			color: t.iconDefault,
			fontSize: 18,
			marginLeft: 4,
			transition: 'transform 200ms ease'
		},
		tooltipL1: {
			fontSize: 13,
			fontWeight: 500,
			padding: '6px 12px',
			borderRadius: 6,
			letterSpacing: 0.2,
			backgroundColor: '#2A2B30',
			color: '#E5E5E5'
		},
		tooltipArrow: {
			color: '#2A2B30'
		},
		footerDivider: {
			backgroundColor: t.border
		}
	};
});
